__turbopack_context__.v({
  "paper": "AmIy4a_paper",
  "paperArrowLeft": "AmIy4a_paperArrowLeft",
  "paperArrowTop": "AmIy4a_paperArrowTop",
});
